const isBlank = str => (str || '').trim().length === 0;
const getDefaultErrorMessage = 'Error happened.';

// prettier-ignore
export const getErrorMessage =
  err => err && !isBlank(err.message) ? err.message : getDefaultErrorMessage;
